import React from "react";
import Header from "../../../Components/Header/Header";

const AudbilityUsers = () => {
  return (
    <div>
      <Header text="Usuários Audbility" style={{ marginBottom: "20px" }} />
      <p>🚧 Esta funcionalidade está em construção...</p>
    </div>
  );
};

export default AudbilityUsers;
